import ICommonFieldData from '../common/ICommonFieldData';

export default interface ICompLocalVersion {
    propertyPhoto: string;
    fieldData: ICommonFieldData[];
}

export function newCompLocalVersion(): ICompLocalVersion {
    const result: ICompLocalVersion = {
        propertyPhoto: '',
        fieldData: []
    };
    return result;
}
